<avano-appheader [isOnErrorPage]="true"></avano-appheader>
<div class="avano-error-content">
  <div class="avano-error-textarea">
    <div class="avano-error-textarea-heading">
      {{ 'avanoErrorPage.msg.header.' + errorNumber | translate }}
    </div>
    <div class="avano-error-textarea-txt">
      {{ 'avanoErrorPage.msg.txt.' + errorNumber | translate }}
    </div>
  </div>

  <div class="avano-error-picturearea-container">
    <div
      class="avano-error-picturearea-image"
      [class.avano-error-picture-internalservererror]="errorNumber === avanoErrorNumbers.INTERNAL_SERVER_ERROR_500"
      [class.avano-error-picture-unauthorized]="errorNumber === avanoErrorNumbers.UNAUTHORIZED_401"
      [class.avano-error-picture-forbidden]="errorNumber === avanoErrorNumbers.FORBIDDEN_403"
      [class.avano-error-picture-notfound]="errorNumber === avanoErrorNumbers.NOTFOUND_404"
    ></div>
  </div>

  <div class="avano-error-footerarea">
    <ng-container [ngSwitch]="errorNumber">
      <ng-container *ngSwitchCase="avanoErrorNumbers.INTERNAL_SERVER_ERROR_500">
        <ng-container *ngTemplateOutlet="onlyBackToLogin"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="avanoErrorNumbers.UNAUTHORIZED_401">
        <ng-container *ngTemplateOutlet="onlyBackToLogin"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="avanoErrorNumbers.FORBIDDEN_403">
        <ng-container *ngTemplateOutlet="onlyBackToLogin"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="avanoErrorNumbers.NOTFOUND_404">
        <ng-container *ngTemplateOutlet="onlyBackToDashboard"></ng-container>
      </ng-container>
      <ng-template #onlyBackToLogin>
        <button
          type="button"
          avanoButton
          [label]="'avanoErrorPage.button.backToLogin' | translate"
          [icon]="'icon-content-login'"
          (click)="backToLogin.emit()"
        ></button>
      </ng-template>
      <ng-template #onlyBackToDashboard>
        <button
          type="button"
          avanoButton
          [label]="'avanoErrorPage.button.backToDashboard' | translate"
          [icon]="'icon-content-login'"
          (click)="backToDashboard.emit()"
        ></button>
      </ng-template>
    </ng-container>
  </div>
</div>
